exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.group-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n", ""]);

// exports
